import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Logo";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const [ready, setReady] = useState(location.state?.user ? true : null);

  useEffect(() => {
    if (location.state?.user) { setReady(true); return; }
    if (loading) return;
    if (!user) {
      nav("/", { replace: true });
    } else {
      setReady(true);
    }
  }, [user, loading, nav, location.state]);

  if (loading || ready === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-white">
        <Logo />
        <div className="mt-8 flex items-center gap-3 text-sm text-black/50">
          <span className="w-2 h-2 bg-[#E60000] animate-pulse" />
          Loading…
        </div>
      </div>
    );
  }
  return ready ? children : null;
};
